import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import type { PAYLATER_PAYMENT_TYPE } from 'constants/payment'
import { PAYPAL_PAYMENT_TYPE } from 'constants/payment'

const paymentMap: { [key: string]: comluxgroup.Payment_1_0_0['type'] } = {
  credit: 'credit',
  braintree: 'braintree',
  gocardless: 'gocardless',
  razorpay: 'razorpay',
  stripe: 'stripe',
  velocity: 'velocity',
  promo: 'promo',
  points: 'points',
  le_points: 'le_points',
  le_points_classic_reward: 'le_points_classic_reward',
  paypal: 'paypal',
  paylater: 'paylater',
  unknown: 'unknown',
  manual: 'manual',
}

const mapPaymentTypeToSnowplow = (type: string, payPalPaymentType: typeof PAYPAL_PAYMENT_TYPE | typeof PAYLATER_PAYMENT_TYPE | null,
): comluxgroup.Payment_1_0_0['type'] => {
  if (type === PAYPAL_PAYMENT_TYPE)
  {
    return payPalPaymentType && paymentMap[payPalPaymentType] ? paymentMap[payPalPaymentType] : 'unknown'
  }
  return paymentMap[type] ? paymentMap[type] : 'unknown'
}

const pspMap: { [key: string]: comluxgroup.Payment_1_0_0['serviceProvider'] } = {
  afterpay: 'afterpay',
  amazonpay: 'amazonpay',
  applepay: 'applepay',
  card: 'card',
  credit: 'credit',
  debit: 'debit',
  emi: 'emi',
  giropay: 'giropay',
  googlepay: 'googlepay',
  link: 'link',
  netbanking: 'netbanking',
  upi: 'upi',
}

const mapServiceProvider = (pspName: string): comluxgroup.Payment_1_0_0['serviceProvider'] => {
  return pspMap[pspName]
}

const paymentContext = (payments: Array<App.OrderPayment>, payPalPaymentType: typeof PAYPAL_PAYMENT_TYPE | typeof PAYLATER_PAYMENT_TYPE | null) => {
  return payments.map(payment => comluxgroup.createPayment_1_0_0({
    amount: payment.amount,
    currency: payment.currencyCode,
    type: mapPaymentTypeToSnowplow(payment.type, payPalPaymentType),
    promo_code: payment.code_name,
    serviceProvider: payment.pspName ? mapServiceProvider(payment.pspName) : undefined,
  }))
}

export default paymentContext
